function keyGenerator(sufix: string = ""): string {
  return Math.floor(Math.random() * 1677721599).toString(16) + sufix
}

export default keyGenerator
